export const NOOP = (): any => null;
